import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthWindowService {
  public authWindow: Window | null = null;
}
